var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-tree-new-normal"},[_vm._v(" hahah "),_c('el-tree-dict',{attrs:{"dictType":"area","maxLevel":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }